<template lang="pug">
  div.map-container.citizen.appeals-map.geo.map-objects
    div.toolbar
      div.line
        h1.title Обращения граждан

    div.new-map
      div(ref="map" v-once).bigmap#map

      transition(name="fade")
        div.legend.legend--objects.cuscroll(:class="showMapLegend ? 'open' : 'close'")
          e-perfect-scrollbar
            div.head(@click="showMapLegend = !showMapLegend")
              h2.title Слои
              //span.toolbar-filter__close
              span.legend__close(v-if="showMapLegend")
              span.legend__open(v-else)
            div(v-for="item, name in layersConf" :class="'type-group ' + item.menuClass")
              div.type
                label.checked
                  input.checkbox(type="checkbox" @change="onLayersChange(item, name)" v-model="layers" :value="name")
                  span
                  span.marker {{item.label}}
                label.new-check
                  input.new-checkbox(type="checkbox")
                  span
              template(v-if="item.groups" v-for="groupItem, groupItemName in item.groups")
                div(v-if="groupItem && !groupItem.hideFromMenu").group
                  div(:class="'type ' + groupItem.menuClass")
                    label.checked
                      input.checkbox(type="checkbox" @change="onLayersChange(groupItem, groupItemName, name)" v-model="layers" :value="groupItemName")
                      span
                      span.marker {{groupItem.label}}

    router-view

</template>

<script>
  import 'leaflet';

  import url from '../../utils/url.js'
  import {MAP, TILE_LAYER, ROUTE_NAME_LAYER_MAP} from '../../config/map.js'
  import {POLYGON} from "../../config/polygon";
  import layersMixin                     from '../../mixins/layers-mixin.js'
  import objectsMixin                    from '@/app/geo/mixins/objects-mixin'
  import {map as mapEndpoints, mongoApi} from '../../api/api-endpoints.js'

  export default {
    name: 'appeals-map',
    data () {

      this.mapLayers = null
      this.map = null

      return {
        layers: []
      }
    },
    mixins: [layersMixin, objectsMixin],
    computed: {
      mapBorders () {
        return this.$store.getters.readUrlEndpoint(
          mapEndpoints.heatMapRegOperators(this.$route.query.zoom || MAP.zoom)
        )
      },
      module () {
        return 'citizen'
      }
    },
    created () {
      // if no layers, select all
      if (!this.$route.query || !this.$route.query.layers) {
        let route = url.getRoute(this.$route)
        route.query.layers = ROUTE_NAME_LAYER_MAP['citizen.appeals']
        this.$router.push(route)
      }
    },
    methods: {
      getMapConfig(key) {
        return MAP[key]
      },
      getMapPolygon () {
        return POLYGON
      },
      drawTiles () {
        L.tileLayer(TILE_LAYER, {}).addTo(this.map)
      },
      getLayersConf(){
        return {
          appeal: {
            endpoint: mongoApi.getAppeals,
            menuClass: 'oth',
            label: 'Категории',
            className: 'cluster-marker',
            iconType: 'wasteCreators',
            groups: {
              unauth: {
                endpoint: mongoApi.getAppeal,
                menuClass: 'svalka-noThrash',
                iconType: 'unauth',
                label: 'Несанкционированные свалка',
                restApiOrder: 1
              },
              schedule: {
                endpoint: mongoApi.getAppeal,
                menuClass: 'svalka-noThrash',
                iconType: 'schedule',
                label: 'Вывоз мусора / График вывоза',
                restApiOrder: 2
              },
              bill: {
                endpoint: mongoApi.getAppeal,
                menuClass: 'svalka-noThrash',
                iconType: 'bill',
                label: 'Тариф',
                restApiOrder: 3
              },
              initiative: {
                endpoint: mongoApi.getAppeal,
                menuClass: 'svalka-noThrash',
                iconType: 'initiative',
                label: 'Предложения',
                restApiOrder: 4
              },
              other: {
                endpoint: mongoApi.getAppeal,
                menuClass: 'svalka-noThrash',
                iconType: 'other',
                label: 'Прочее',
                restApiOrder: 5
              }
            }
          }
        }
      },
      getCopyWithoutObservers(data){
        let res = {}
        console.log('getCopyWithoutObservers - ', data)
        // adapter, convers grid to valid fromat
        let raw = JSON.parse(JSON.stringify(data))
        if (raw && raw.data) {
          raw.data.forEach(v => {
            if(!res.hasOwnProperty(v.cat_id)){
              res[v.cat_id] = []
            }
            res[v.cat_id].push(Object.assign(v, {
              lat: v.latitude || 0,
              lng: v.longitude || 0
            }))
          })
        }
        console.log('getCopyWithoutObservers = ', res)
        return res
      },
      afterMapInit() {
        this.initObjectsLayerDrawer()
      },
      getParentsConf (layersArr, conf) {
        return layersMixin.methods.getParentsConf(layersArr, conf)
      },
      getLayerEndpoint (conf, type, route) {
        return layersMixin.methods.getLayerEndpoint(conf, type, route)
      },
      afterReCreateMap () {
        //this.objectsLayerDrawer.removeLayers()
        //this.mapLayers = null
        this.afterMapInit()
      }
    },
    asyncData ({store, route, fromRoute, methods}) {
      let promises = []
      let usedRoute = url.getPrevOrCurrentRoute(route)

      if(usedRoute.query && usedRoute.query.layers && typeof usedRoute.query.layers === 'string'){
        let conf = methods.getParentsConf(usedRoute.query.layers.split(','), methods.getLayersConf())
        for(let key in conf){
          if(methods.getLayerEndpoint(conf, key, usedRoute)){
            // console.log('asyncData ' + methods.getLayerEndpoint(conf, key, route))

            promises.push(store.dispatch('updateUrlEndpoint', {
              endpoint: methods.getLayerEndpoint(conf, key, usedRoute),
              cache: (60 * 60 * 24 * 1000)
            }))
          }
        }
      }

      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.heatMapRegOperators(route.query.zoom || MAP.zoom),
        fromCache: true
      }))

      if(promises.length === 0){
        return Promise.resolve(1)
      }

      return Promise.all(promises)
    }
  };
</script>
